export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  sm: 'w-4 h-4',
  md: 'w-6 h-6',
  lg: 'w-12 h-12',
} as const;

export function Spinner({ size = 'md', className = '' }: SpinnerProps) {
  const sizeClass = sizeClasses[size];

  return (
    <svg
      role="status"
      aria-label="Loading"
      className={`${sizeClass} text-sd-primary animate-spin motion-reduce:animate-none ${className}`.trim()}
      viewBox="0 0 24 24"
      fill="none"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="3"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
      />
    </svg>
  );
}
